// tslint:disable: no-inferrable-types

import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';

import { EasFormControl } from './easform';
import { GMCValidationError, GMCValidatorService } from '../gmc-form-control';
import { FormControl } from "@angular/forms";

@Component({
    selector: 'eas-easform-control-single',
    templateUrl: './easform-control-single.component.html',
    styleUrls: ['./easform-control-single.component.css'],
    standalone: false
})
export class EasFormControlSingleComponent implements OnDestroy, OnChanges, OnInit{
  @Input() easControl!: EasFormControl;
  @Input() templates = {};
  /**
   * Weather the read-only fields should be visible regardless their values.
   *
   * By default the field is ommited from the form if it does not have value
   * which it does not in the Workflow Editor - From preview.
   */
  @Input() forceDisplayReadOnly: boolean = false;

  private unsubscribe: Subject<void> = new Subject();
  public isLoading: boolean = false;

  _categories$ = new BehaviorSubject<any[]>([]);
  categories$ = this._categories$.asObservable().pipe(
    distinctUntilChanged()
  );

  public searchCtrl: FormControl = new FormControl();
  public filteredOptions$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  public errors;
  public currentErrors: string[] = []

  constructor() {
    this.errors = this.errorMessages();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['easControl'] && this.easControl) {
      this.handleErrors();
    }
  }

  readOnlyVisibility: boolean = false;

  private errorMessages() {
    const messages = { required: () => $localize `This field is required` };

    messages[GMCValidatorService.FormatValidatorErrorKey] =
      (value: GMCValidationError) => $localize `GMC Number '${value.value}' is not valid!`;

    messages[GMCValidatorService.CorrectnessValidatorErrorKey] =
      (value: GMCValidationError) => $localize `GMC Number '${value.value}' could not be verified!`;

    return messages;
  }

  handleErrors() {
    this.currentErrors = [];
    if (this.easControl.control?.errors) {
      for (const key in this.easControl.control.errors) {
        this.currentErrors = this.errors[key](key);
      }
    }
  }

  ngAfterViewInit() {

  }
 ngOnInit() {
    const options = this.easControl.field.options || {};

    if (options.categories) {
      if (!options.required && this.easControl.field.widget!.type === "simpleSelect") {
        const key = options.key || 'id';
        const categories = [{ name: 'None', [key]: null }, ...options.categories];
        this._categories$.next(categories);
      } else {
        this._categories$.next(options.categories);
      }
    } else if (options.categoriesFactory) {
      this.updateOptions();
    }

    // Subscribe to value changes on search control
    if (["multiSelect", "simpleSelect"].includes(this.easControl.field.widget.type)) {
      this.filterOptions();
      this.searchCtrl.valueChanges
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(() => this.filterOptions());
    }
    this.readOnlyVisibility = this.getReadOnlyVisibility();
    this.easControl.control?.statusChanges.subscribe(() => {
      this.handleErrors()
    });
  }

  updateOptions($event = null) {
    const options = this.easControl.field.options || {};
    if ($event !== null && !options.updateOnOpen) {
      return;
    }
    if (options.categoriesFactory) {
      const root = this.easControl.root;
      this._categories$.next(options.categoriesFactory(
        this.easControl,
        this.easControl.control.value,
        this.easControl.parent?.parent?.control?.value,
        root.control?.value
      ));
    }
  }

  protected filterOptions() {
    if (!this._categories$.value) {
      return;
    }
    let search = this.searchCtrl.value;
    if (!search) {
      this.filteredOptions$.next(this._categories$.value.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredOptions$.next(
      this._categories$.value.filter(option => option.name.toLowerCase().indexOf(search) > -1 && option.value !== '')
    );
  }

  private getReadOnlyVisibility() {
    const widgetType = this.easControl.field.widget.type;
    if (['heading', 'paragraph'].includes(widgetType)) {
      return true;
    }
    return !!this.easControl.readableValue;
  }

  displayFn(): ((value: any) => string) | null {
    if (!this._categories$) { return null; }

    return (value: any): string => {
      const idField = this.easControl.field.options && this.easControl.field.options['key'] || 'id';
      const opt = this._categories$.value.find(itm => itm[idField] === value);
      return opt !== undefined ? opt.name : '';
    };
  }

  clearSearch() {
    this.easControl.control.setValue(null);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
  }
}
